import { useContext } from 'react';
import { type Maybe } from '../../../api/types';
import { RouterContext, type RouterContextPayload, RouterRoutesContext } from './Context';

export const useRouterRoutes = () => useContext(RouterRoutesContext);

/* eslint-disable no-redeclare */
export function useRouter(required: true): RouterContextPayload;
export function useRouter(required?: false): Maybe<RouterContextPayload>;
export function useRouter(required?: boolean): RouterContextPayload {
    const context = useContext(RouterContext);

    if (required && !context) {
        throw new Error('Router context is missing in React tree');
    }

    return context;
}
/* eslint-enable no-redeclare */
